import * as React from "react";
export const DynamicSelect = (props: { id?: string, className?: string, value: string|number|undefined, options: Array<{ id: string|number|undefined, name: string, disabled?: boolean }>, onSelectionChanged?: (id: string|number) => void }) => {
	const options = props.options.map(opt => <option key={opt.id} value={opt.id} disabled={opt.disabled}>{opt.name}</option>);

	function handleChange(event: React.ChangeEvent<HTMLSelectElement>) {
		if (props.onSelectionChanged)
			props.onSelectionChanged(event.target.value);
	}

	return (<select id={props.id} className={`form-control ${props.className}`} value={props.value} onChange={handleChange}>
		{options}
	</select>);
}